<script lang="ts">
  import clsx from 'clsx'
  import componentAttributesStore from '../../../../stores/componentAttributes.svelte'
  import withPreventDefault from '../../../../utils/withPreventDefault'
  import ChevronIcon from '../../icons/ChevronIcon.svelte'
  import { THEMES } from '../../../../const/themes'

  type Props = {
    onclick: () => void
    hidden?: boolean
    label: string
    icon?: any
  }
  const { onclick, hidden = false, label, icon }: Props = $props()

  const onClick = (e: MouseEvent) =>
    withPreventDefault(e, () => {
      onclick()
    })
</script>

<li class="pl-3 w-full">
  <button
    class={clsx(
      'flex items-center w-full space-x-2',
      hidden ? 'hidden' : 'flex',
    )}
    onclick={(e) => onClick(e)}
  >
    {#if icon}<div
        class="h-6 w-6"
        style="stroke: {componentAttributesStore.state.buttonsColor ||
          THEMES.DEFAULT.BUTTONS_COLOR};"
      >
        {@render icon?.()}
      </div>{/if}
    <span class="flex-1 text-left">{label}</span>
    <span>
      <ChevronIcon />
    </span>
  </button>
</li>
